import { createElement as e } from "react";
import { Switch, Route } from "react-router";
import Header from "../components/Header";
import { Navbar, Nav, Glyphicon } from "react-bootstrap";
import AccountNav from "../components/AccountNav";
import NavItemLink from "sc/ui/components/NavItemLink";
import PageNotFound from "sc/ui/sites/oncall/pages/PageNotFound";
// Users
import UsersPage from "../pages/admin/users/List";
import AddUser from "../pages/admin/users/Add";
import EditUserPage from "../pages/admin/users/Edit";
import EditUserPartnerPage from "../pages/admin/users-partners/Edit";
import AddUserPartnerPage from "../pages/admin/users-partners/Add";
// Partners
import Partners from "../pages/admin/Partners";
import EditPartnerPage from "../pages/admin/EditPartnerPage";
import AddPartnerPage from "../pages/admin/AddPartnerPage";

const Menu = () =>
  e(
    Navbar.Collapse,
    { className: "pull-right" },
    e(
      Nav,
      null,
      e(
        NavItemLink,
        { eventKey: "1", href: "/" },
        e(Glyphicon, { glyph: "glyphicon glyphicon-home" }),
        " Partners",
      ),
    ),
    e(
      Nav,
      null,
      e(
        NavItemLink,
        { id: "admin-users-menu-item", eventKey: "2", href: "/users" },
        e(Glyphicon, { glyph: "glyphicon glyphicon-lock" }),
        " SecurityCoverage Users",
      ),
    ),
    e(Nav, null, e(AccountNav)),
  );

export default () =>
  e(
    "div",
    { id: "admin-app" },
    e(Header, { MenuComponent: Menu }),
    e(
      Switch,
      null,
      e(Route, { path: "/", component: Partners, exact: true }),
      // Users
      e(Route, { path: "/users", component: UsersPage, exact: true }),
      e(Route, { path: "/users/new", component: AddUser, exact: true }),
      e(Route, {
        path: "/user/edit/:id",
        component: EditUserPage,
        exact: true,
      }),
      // Partners
      e(Route, {
        path: "/partner/users/new/:partnerId",
        component: AddUserPartnerPage,
        exact: true,
      }),
      e(Route, {
        path: "/partner/users/edit/:partnerId/:id",
        component: EditUserPartnerPage,
        exact: true,
      }),
      e(Route, {
        path: "/partner/edit/:id",
        component: EditPartnerPage,
        exact: true,
      }),
      e(Route, {
        path: "/partner/new",
        component: AddPartnerPage,
        exact: true,
      }),

      e(Route, { path: "*", component: PageNotFound, exact: true }),
    ),
  );



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/routes/Admin.js